const logger = {
  log: (message: any, ...args: any[]) => {
    onLog(message, ...args);
  },
  error: (message: any, ...args: any[]) => {
    onError(message, ...args);
  },
  warn: (message: any, ...args: any[]) => {
    onWarn(message, ...args);
  },
  info: (message: any, ...args: any[]) => {
    onInfo(message, ...args);
  },
  debug: (message: any, ...args: any[]) => {
    onDebug(message, ...args);
  },
};

// Add a property to track initialization
let loggerInitialized = false;

const checkEnvironment = () => {
  // Only log in development environment
  const isDev = import.meta.env.DEV === true ||
                import.meta.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1';

  // Show initialization message only once in development
  if (isDev && !loggerInitialized) {
    console.log(`%c[LOGGER SYSTEM] Logger initialized in development mode`, 'color: green; font-weight: bold');
    loggerInitialized = true;
  }

  return isDev;
};
  
const onLog = (message: any, ...args: any[]) => {
  if(checkEnvironment()) {
    if (args.length > 0) {
      console.log(`%c[LOGGER] ${message}`, 'color: #0077cc; font-weight: bold', ...args);
    } else {
      console.log(`%c[LOGGER] ${message}`, 'color: #0077cc; font-weight: bold');
    }
  }
};

const onError = (message: any, ...args: any[]) => {
  if(checkEnvironment()) {
    if (args.length > 0) {
      console.error(`%c[LOGGER-ERROR] ${message}`, 'color: #ff3333; font-weight: bold', ...args);
    } else {
      console.error(`%c[LOGGER-ERROR] ${message}`, 'color: #ff3333; font-weight: bold');
    }
  }
};

const onWarn = (message: any, ...args: any[]) => {
  if(checkEnvironment()) {
    if (args.length > 0) {
      console.warn(`%c[LOGGER-WARN] ${message}`, 'color: #ff9900; font-weight: bold', ...args);
    } else {
      console.warn(`%c[LOGGER-WARN] ${message}`, 'color: #ff9900; font-weight: bold');
    }
  }
};

const onInfo = (message: any, ...args: any[]) => {
  if(checkEnvironment()) {
    if (args.length > 0) {
      console.info(`%c[LOGGER-INFO] ${message}`, 'color: #00cc99; font-weight: bold', ...args);
    } else {
      console.info(`%c[LOGGER-INFO] ${message}`, 'color: #00cc99; font-weight: bold');
    }
  }
};

    const onDebug = (message: any, ...args: any[]) => {
  if(checkEnvironment()) {
    if (args.length > 0) {
      console.debug(`%c[LOGGER-DEBUG] ${message}`, 'color: #9966cc; font-weight: bold', ...args);
    } else {
      console.debug(`%c[LOGGER-DEBUG] ${message}`, 'color: #9966cc; font-weight: bold');
    }
  }
};


export default logger;